export function buildLoadingActionMap(groups) {
  return Object.entries(groups).reduce((acc, [key, thunk]) => {
    if (!thunk?.pending || !thunk?.fulfilled || !thunk?.rejected) {
      return acc;
    }

    acc[thunk.pending.type] = key;
    acc[thunk.fulfilled.type] = key;
    acc[thunk.rejected.type] = key;
    return acc;
  }, {});
}

export function createLoadingMatcher(actionMap) {
  const trackedTypes = new Set(Object.keys(actionMap));
  return (action) => trackedTypes.has(action.type);
}

export function createLoadingSliceState(keys) {
  return keys.reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {});
}
